import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';

export const AdminIamRoutes: RouteRecordRaw[] = [
    {
        path: '',
        component: wrapRuntimeImport(() => import('./screens/landing.vue')),
        meta: { admin: true }
    },
    {
        path: 'users',
        component: wrapRuntimeImport(() => import('./screens/users.vue')),
        meta: { admin: true }
    },
    {
        path: 'roles',
        component: wrapRuntimeImport(() => import('./screens/roles.vue')),
        meta: { admin: true }
    },
    {
        path: 'permissions',
        component: wrapRuntimeImport(() => import('./screens/permissions.vue')),
        meta: { admin: true }
    },
    {
        path: 'encryption',
        component: wrapRuntimeImport(() => import('./screens/encryption.vue')),
        meta: { admin: true },
        redirect: '/admin/iam/encryption/overview',
        children: [
            {
                path: 'overview',
                component: wrapRuntimeImport(() => import('./screens/encryption/overview.vue')),
                meta: { admin: true }
            },
            {
                path: 'devices',
                component: wrapRuntimeImport(() => import('./screens/encryption/devices.vue')),
                meta: { admin: true }
            },
            {
                path: 'certificates',
                component: wrapRuntimeImport(() => import('./screens/encryption/certificates.vue')),
                meta: { admin: true }
            },
            {
                path: 'authorities',
                component: wrapRuntimeImport(() => import('./screens/encryption/authorities.vue')),
                meta: { admin: true }
            },
            {
                path: 'recovery',
                component: wrapRuntimeImport(() => import('./screens/encryption/recovery.vue')),
                meta: { admin: true }
            }
        ]
    },
    {
        path: 'idp',
        component: wrapRuntimeImport(() => import('./screens/idp.vue')),
        meta: { admin: true }
    },
    {
        path: 'advanced',
        component: wrapRuntimeImport(() => import('./screens/advanced.vue')),
        meta: { admin: true }
    }
];
